
const tr = {
    en: {
        paymentPrompt: "Setup 1O1O/csl/Club Sim Subscriptions",
        paymentPrompt2: "Please enter your mobile number",

        noMobileNoInput: "Please enter mobile number.",
        invalidMobileNo: "Mobile number is not correct, please try again.",
        bindingSaveRequired: "You must agree to save your mobile number to continue.",
        inputPlaceholder: "1O1O/csl/Club Sim mobile number",

        saveCheckboxTxt: "I agree to the disclosure of my Now E subscription information under my 1O1O/csl/Club Sim account, by CSL Mobile Limited to PCCW Media Limited for provision of the Now E service and related purposes.",

        continueBtnTxt: "Continue",
        cancelBtnTxt: "Back",
    },
    zh: {
        paymentPrompt: "設定1O1O/csl/Club Sim計劃或組合",
        paymentPrompt2: "請輸入您的手機號碼",

        noMobileNoInput: "請輸入手機號碼。",
        invalidMobileNo: "手機號碼不正確，請重新輸入。",
        bindingSaveRequired: "You must agree to save your mobile number to continue.",
        inputPlaceholder: "1O1O/csl/Club Sim手機號碼",

        saveCheckboxTxt: "本人同意香港移動通訊有限公司向電訊盈科媒體有限公司披露本人1O1O/csl/Club Sim賬戶下之Now E 訂購資料以提供Now E服務及相關目的。",

        continueBtnTxt: "繼續",
        cancelBtnTxt: "返回",
    }
}

export default tr;
